export default __webpack_public_path__ + "static/media/img-view-two.7dc13051.jpg";